// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './Login.vue'
import router from './router/login'
import iView from 'iview'
import 'iview/dist/styles/iview.css'
import axios from 'axios'
import store from './store/index'
import StoreSaveData from './static/js/storeSaveData'  // 获取登录后储存的信息
import * as filters from "./static/js/filters";
import kfzModal from './components/kfz/index';
import VerifyId from "./components/VerifyId";
import utils from './static/js/utils/index'
import upMaterial from './components/upMaterial'  // 上传材料
import SInput from './components/s-input'  // 枚举组件


import { Popover } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(upMaterial); // 上传文件
Vue.use(SInput);  // 全局Sinput
Vue.component(Popover.name, Popover);


// 验证全部数据sInput
import verifySAllItem from './components/s-input/verifySAllItem';
// 获取全部数据sInput
import showSItem from './components/s-input/showSItem'
// 获取报盘数据展示格式化方法
import SBatchFormat from './components/s-input/SBatchFormat'
// 获取sinput数据key:value
import getSItem from './components/s-input/getSItem'

//验证sinput数据格式化
Vue.prototype.$verifySAllItem = verifySAllItem;
// 获取全部数据sInput
Vue.prototype.$showSItem = showSItem;
// 获取报盘数据展示格式化方法
Vue.prototype.$SBatchFormat = SBatchFormat;
// 获取sinput数据key:value
Vue.prototype.$getSItem = getSItem;
//关闭生产模式下给出的提示
// Vue.config.productionTip = false;
/* eslint-disable no-new */

// axios设置，baseURl，请求拦截器，响应拦截器
axios.defaults.baseURL = process.env.API_URL;
// axios.defaults.baseURL = 'http://localhost:9001';
//  请求拦截器
axios.interceptors.request.use(config => {
    const userToken = sessionStorage.getItem('userToken')
    if (userToken !== 0 && userToken !== null) {
        config.headers.userToken = sessionStorage.getItem('userToken');
    }
    return config;
});

// 公共方法集合
Vue.prototype.$utils = utils;
// 过滤器
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

// 插件注册
Vue.use(iView);
Vue.use(kfzModal);
Vue.use(VerifyId);

// axios挂载到Vue
Vue.prototype.$http = axios;
// 获取保存在本地储存中的登录者信息
Vue.prototype.$logininfo = () =>{
  return StoreSaveData('loginInfo');
};

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {App}
});




// WEBPACK FOOTER //
// ./src/login.js